export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Linha de"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["a"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["caracteres"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valor inválido"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo obrigatório"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confira os campos"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Máx."])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SVG, PNG ou JPG"])}
}